import { createEvent } from 'effector';

import { CompaignManagementState } from './CompaignManagementState';

export const compaignManagementEvent =
  createEvent<Partial<CompaignManagementState>>('compaignManagementEvent');
